import {createStore} from 'vuex'
import meManager from "../api/Me";
import BuFieldModule from "@/store/BuFieldModule";
import SottoprogettoDataManager from "@/store/SottoprogettoDataManager";
import {removeToken, setToken} from "@/api/api";
import router from '@/router'

export default createStore({
    state: {
        menu_visible: false,
        user: null,
        permissions: {},
        groups: {},
        counters: {
            ok: 0,
            clienti: 0,
            in_scadenza: 0,
            scaduti: 0,
            contatti: 0,
            notification_counter: 0
        }
    },
    mutations: {
        show_menu(state) {
            state.menu_visible = true
        },
        hide_menu(state) {
            state.menu_visible = false
        },
        toggle_menu(state) {
            state.menu_visible = !state.menu_visible
        },
        set_user(state, val) {
            state.user = val
        },
        set_counters(state, val) {
            state.counters = val
        },
        set_permissions(state, val) {
            val.forEach((p: string) => {
                // @ts-ignore
                state.permissions[p] = p
            })
        },
        set_groups(state, val) {
            val.forEach((p: string) => {
                // @ts-ignore
                state.groups[p] = p
            })
        }
    },
    actions: {
        fetchUser(context) {
            return meManager.me().then((res) => {
                context.commit('set_user', res.data)
            }).catch(() => {
                context.commit('set_user', null)
            })
        },
        fetchCounters(context) {
            return meManager.counters().then((res) => {
                context.commit('set_counters', res.data)
            }).catch(() => {
                context.commit('set_counters', null)
            })
        },
        logout(context) {
            localStorage.removeItem('next-token')
            removeToken()
            context.commit('set_user', null)
        },
        fetchPermissions({commit}) {
            return meManager.permissions().then((res) => {
                commit('set_permissions', res.data)
            })
        },
        fetchGroups({commit}) {
            return meManager.groups().then((res) => {
                commit('set_groups', res.data)
            })
        },
        init({dispatch}) {
            const token = localStorage.getItem('next-token')
            if (token) {
                setToken(token)
                return dispatch("fetchUser").then(() => Promise.all([dispatch("fetchPermissions"), dispatch("fetchGroups")]))
            }
            return Promise.reject(null)
        }
    },
    getters: {
        me(state) {
            return state.user
        },
        meCounters(state) {
            return state.counters
        },
        labelGender(state) {
            // @ts-ignore
            if (state?.user?.sesso) {
                // @ts-ignore
                return state.user.sesso == 'F' ? 'Bentornata' : 'Bentornato'
            }
            return 'Bentornato'
        },
        isNewBusiness(state) {
            if (state?.user) {
                // @ts-ignore
                return state.user.bu_label == 'NB'
            }
            return false
        },
        isAuthenticated(state) {
            return state.user != null
        },
        hasNinjaId(state){
            // @ts-ignore
            return state?.user?.ninja_uid
        },
        // console.log(this.hasPermission('show contatti'))
        hasPermission: (state) => (permission: string) => {
            return Object.prototype.hasOwnProperty.call(state.permissions, permission)
        },
        hasGroup: (state) => (group: string) => {
            return Object.prototype.hasOwnProperty.call(state.groups, group)
        },
    },
    modules: {
        buFieldModule: BuFieldModule,
        sprjDataManager: SottoprogettoDataManager,
    }
})
